<style src="./Distributors.scss" lang="scss" scoped></style>
<template>
  <section class="distributors">
    <content-header path="Cadastro / Distribuidores"/>

    <form v-on:submit.prevent="submitSearch">
      <section class="form-box row">
        <textbox
          v-model="filter.searchText"
          label="Buscar produto"
          placeholder="Digite o nome do produto"
          :class="{'col-9': showInsertNew, 'col-12': !showInsertNew}"
          :autofocus="true"
          :debounce="250"
          @debounce="submitSearch"/>

        <button class="btn-primary col-3" @click="addNew" v-if="showInsertNew">
          <icon-add />
          <span class="hide-md">Inserir Novo</span>
        </button>
      </section>
    </form>

    <section class="form-box">
      <page-navigator
        :total-pages="paginator.totalPage"
        :per-page="paginator.perPage"
        v-model="paginator.actualPage" />
      <distributor-map
        :list-data="filteredList"
        @selected="selectItem" />
    </section>

    <right-side-panel ref="rspNewCmed" title="Atualizar CMED" :shortcut="['alt', 'n']">
      <new-distributor @refresh-list="refreshList" />
    </right-side-panel>
    <right-side-panel ref="rspNewCmed" title="Atualizar CMED" :shortcut="['alt', 'n']">
      <edit-distributor @refresh-list="refreshList" />
    </right-side-panel>

  </section>
</template>

<script>
import ContentHeader from '@/components/foundation/content-header/ContentHeader'
import RightSidePanel from '@/components/foundation/right-side-panel/RightSidePanel'
import NewDistributor from './components/new/DistributorNew.vue'
import EditDistributor from './components/edit/DistributorEditor.vue'
import { Textbox, SourcePaginatorMixin, PageNavigator } from '@/components/primitives'
import { IconAdd, IconEmpty } from '@/components/primitives/icons'
import { ListPaginated } from '@/brain/record/distributor'
import DistributorMap from './components/distributor-map/DistributorMap.vue'

export default {
  name: 'Distributor',
  components: {
    PageNavigator,
    ContentHeader,
    RightSidePanel,
    Textbox,
    IconAdd,
    IconEmpty,
    NewDistributor,
    EditDistributor,
    DistributorMap
  },
  extends: {
    ...SourcePaginatorMixin
  },
  data () {
    return {
      filter: {
        searchText: ''
      },
      filteredList: []
    }
  },
  watch: {
    paginator: {
      handler () {
        this.submitSearch()
      },
      deep: true
    }
  },
  computed: {
    showInsertNew () {
      return this.$route.meta.mainArea !== 'research'
    }
  },
  mounted () {
    this.submitSearch()
  },
  methods: {
    addNew () {
      this.$refs.rspNewCmed.showPanel()
    },
    refreshList () {
      this.loadAll()
    },
    submitSearch () {
      if (this.filter.searchText.length < 1) {
        this.filteredList = []
        this.paginator.totalRegister = 0
        this.paginator.totalPage = 0
        return false
      }
      const params = this.buildQuery({ filters: this.filter })

      ListPaginated({ params })
        .then((result) => {
          this.filteredList = result.list
          this.paginator.totalRegister = result.rows
          this.paginator.totalPage = Math.floor(result.rows / this.paginator.perPage)
        })
    },
    selectItem (item) {
      this.$router.push({ name: 'DistributorEditor', params: { id: item._id } })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/record/distributor/Distributors.vue